module.exports = __webpack_public_path__ + "static/media/ic_covid_b_1_fisdom.7fe44253.svg";